import { SoldProductType, TicketLineDTO } from 'core/api';

export type GiftLine = { line: TicketLineDTO, selected: boolean };

export type GiftSelection = {
	lines: GiftLine[],
	areAllChecked: boolean
}

export function toggleLineSelection(currentState: GiftSelection, selectedLine: TicketLineDTO): GiftSelection {

	if (selectedLine.Type === SoldProductType.MenuItem)
		return currentState;

	const newLines = currentState.lines.map(giftLine => {
		return giftLine.line.Id === selectedLine.Id || giftLine.line.OwnerId === selectedLine.Id
			? { line: { ...giftLine.line }, selected: !giftLine.selected }
			: { ...giftLine };
	});

	const newAreAllChecked = newLines.every(giftLine => giftLine.selected);

	return { ...currentState, lines: newLines, areAllChecked: newAreAllChecked };
}

export function selectAll(currentState: GiftSelection): GiftSelection {
	const newLines = currentState.lines.map(x => ({ line: x.line, selected: true }));
	return { lines: newLines, areAllChecked: true };
}

export function unSelectAll(currentState: GiftSelection): GiftSelection {
	const newLines = currentState.lines.map(x => ({ line: x.line, selected: false }));
	return { lines: newLines, areAllChecked: false };
}

export function init(lines: TicketLineDTO[]): GiftSelection {
	const newLines = lines.map(x => ({ line: x, selected: true }));
	return { lines: newLines, areAllChecked: true };
}
